module.exports = __webpack_public_path__ + "img/line-right.14bb2292.svg";